// extracted by mini-css-extract-plugin
export var container = "_co-1";
export var cornerButtonContainer = "_co-6";
export var disabled = "_co-2";
export var dragActive = "_co-3";
export var fileContainer = "_co-5";
export var hiddenInput = "_co-4";
export var widthContainer = "_co-0";